import { Popup } from 'antd-mobile'
import React, { useEffect, useReducer, useState } from 'react'
import './css/IncomeAlert.css'
import useActiveState from '../../../lib/useActiveState'
import general, { redux } from "../../../general";
import Dialog from '../../../lib/Dialog';
import { BoxType } from '../../../BoxType';

export function useSelectAccount() {

  const [visible, setVisible] = useState(false)
  const [xhList, setList] = useState([])
  const [selectAccountInfo, setSelectAccountInfo] = useActiveState('selectAccountInfo')

  useEffect(() => {
    redux.subscribe(() => {
      const state = redux.getState()
      if (state.list) {
        setList(redux.getState().list)
        state.list.map((item) => {
          if (item.is_default == true) {
            selectAccountInfoChange(item)
          }
        })
      }
      if (state.visible) {
        setVisible(redux.getState().visible)
      }
    })
  }, [])

  const visibleChange = (value,topic_id) => {
    redux.dispatch({
      type: 'visible',
      data: {
        visible: value,
        topic_id
      }
    })
  }

  const selectAccountInfoChange = (params) => {
    setSelectAccountInfo(params)
  }

  const appendTopic_id = (topic_id) => {
    return `${topic_id}-${Date.now()}`
  }

  const detachTopic_id = (topic_id) => {
    if (topic_id.indexOf('-') !== -1) {
      return topic_id.split('-')[0]
    } else {
      return topic_id
    }
  }

  return { xhList, visibleChange, selectAccountInfo, selectAccountInfoChange, appendTopic_id, detachTopic_id }
}

export default function SelectAccount(props) {

  const { visibleChange, selectAccountInfo, selectAccountInfoChange, detachTopic_id } = useSelectAccount()
  const [index, setIndex] = useState(0)
  const [list, setList] = useState([])
  const [visible, setVisible] = useState(false)

  const getData = () => {
    general.axios.post('/user/userDependent/getUserTrumpetXhData', { topic_id: detachTopic_id(props.topic_id) })
      .then(res => {
        const { status, data } = res.data
        if (status.succeed == 1) {
          redux.dispatch({
            type: 'list',
            data: {
              list: data
            }
          })
          setList(data)
          data.map((item, idx) => {
            if (item.is_default == true) {
              setIndex(idx)
              selectAccountInfoChange(item)
            }
          })
          if (props.handleRequetXHData) {
            props.handleRequetXHData(data)
          }
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  useEffect(() => {
    if (props.topic_id?.length > 0) {
      getData()
      redux.subscribe(() => {
        const state = redux.getState()
        if (state.visible && state.topic_id == props.topic_id) {
          setVisible(state.visible)
        }
      })
    }
  }, [props.topic_id])

  const close = () => {
    visibleChange(false)
    setVisible(false)
  }

  const done = () => {
    visibleChange(false)
    setVisible(false)
    if (props.handleCompletion) {
      props.handleCompletion(list[index])
    }
  }

  return (
    <Popup
      visible={visible}
      bodyStyle={{
        borderTopLeftRadius: '13px',
        borderTopRightRadius: '13px',
        padding: '15px 15px 0'
      }}>
      <div className='xh-alert-container'>
        <div className="alert-title" >请选择领取的小号</div>
        <div className="content">
          {list.map((item, idx) => {
            return (
              <div className='item' onClick={() => {
                setIndex(idx)
              }}>
                <div className={'title ' + (index == idx ? 'active' : '')}>{item?.alias}</div>
                <img height={17} src={'resources/250410/' + (index == idx ? `xh-select-${BoxType}` : 'xh-normal') + '.png'} alt="" />
              </div>
            )
          })}
        </div>
        <div className="actions">
          <div className="cancel btn" onClick={close}>取消</div>
          <div className="done btn" onClick={done}>确定</div>
        </div>
      </div>
    </Popup>
  )
}
